import {DynamicPageServerSideProps} from '@/_application/core/types';
import BrandProducts from '@/_application/pages/brand/components/brand-products';
import BrandDescription from '@/_application/pages/brand/components/brand-description';

function BrandPageDesktop({variables}: Readonly<DynamicPageServerSideProps>) {
    if (!variables?.brand?.label) {
        return null;
    }

    return (
        <div className="flex justify-center gap-5 bg-secondary">
            <div className="w-full py-5 lg:w-[1204px]">
                <BrandProducts
                    brand={variables?.brand}
                    initialProducts={variables.products?.products}
                    productListItemsQueryOptions={variables.productListItemsQueryOptions}
                />
                {variables?.brand?.description && <BrandDescription description={variables?.brand?.description} />}
            </div>
        </div>
    );
}

export default BrandPageDesktop;
